:host {
	display: block;
	position: relative;
	min-width: min(calc(100% - 1rem), 30rem);
	min-height: 3rem;
	border-radius: 5px;
	margin: 0.5rem;
}
:host > span.icon > smoothly-icon,
:host > span.clean {
	display: flex;
	justify-content: center;
	align-self: center;
}
:host > span {
	margin-inline: 1rem 2rem;
}
:host > span.icon {
	display: flex;
	width: 100%;
	justify-content: center;
}
:host > span.icon > p {
	padding-right: 1em;
}
:host > span > p {
	text-align: left;
}
:host[hidden] {
	display: none;
}
:host > span.icon > smoothly-icon {
	margin: 0 0.5rem;
}
:host > smoothly-trigger {
	--smoothly-icon-size: 1.6rem;
	position: absolute;
	right: 0;
}
